<div *ngIf="user?.isOnWaitlist && !hideBanner"
(click)="openWaitlistModal()"
     class="waitlist-banner cursor-pointer text-center text-white font-medium font-family-sans p-1 mt-auto line-height-4"
     style="background: linear-gradient(135deg, #1FBDD5 0%, #2B96F1 48.12%, #745AFA 95.11%, #7857FB 97.63%, #7C54FB 100%);">

  <span class="text-white">
Skip the waitlist (est. 3 months) &nbsp;<span class="text-white font-semibold underline">Try Premium For $1</span>
  </span>
</div>
